import { NodeSearchResult } from 'pages/api/search/[keywords]';
import useSWR from 'swr';
import { calculateOffset, POSTS_PER_PAGE } from 'utils/shared';

const fetcher = (...args: Parameters<typeof fetch>) => fetch(...args).then((res) => res.json());

export default function usePostsSearch(input: string, page: number, itemsPerPage = POSTS_PER_PAGE) {
  const start = calculateOffset(page);
  const skipSearch = input.trim().length < 3;
  const { data: totalData, error: totalDataError } = useSWR(
    skipSearch ? null : `${process.env.NEXT_PUBLIC_BASE_PATH}/api/search/${encodeURIComponent(input)}/`,
    fetcher,
  );

  const { data, error } = useSWR<NodeSearchResult>(
    skipSearch
      ? null
      : `${process.env.NEXT_PUBLIC_BASE_PATH}/api/search/${encodeURIComponent(
          input,
        )}/?limit=${itemsPerPage}&start=${start}`,
    fetcher,
  );
  return {
    posts: data?.posts ?? [],
    isLoading: !skipSearch && !error && !data,
    total: totalData?.total ?? 0,
    isLoadingTotal: !skipSearch && !totalData && !totalDataError,
  };
}
